import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class OpeningService {

  constructor(private http: HttpClient, private restService: RestService) {}

  // all(params: string = '') {
  //   let val_params = params != null ? '?' + params : '';
  //   return this.restService.all('citietouristic/all', val_params);
  // }
  
  // list(params: string = '') {
  //   let val_params = params != null ? '?' + params : '';
  //   return this.restService.all('citietouristic/list', val_params);
  // }

  getCheckBoxSlected(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('money/checkboxselected', val_params);
  }

  getBoxOpening(val_id: number) {
    return this.restService.get('money/boxopening', val_id);
  }

  openBox(data: any) {
    return this.restService.save('money/openbox', data);
  }

  closeBox(data: any) {
    return this.restService.save('money/closebox', data);
  }

  updateBoxSelected(val_id: number, data: any) {
    return this.restService.update('money/update/boxselected', val_id, data);
  }

  listHistoryBox(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('money/historybox/list', val_params);
  }

  getHistoryBoxDetail(val_id: number) {
    return this.restService.get('money/historybox/detail', val_id);
  }

  // delete(val_id: number) {
  //   return this.restService.delete('citietouristic/delete', val_id);
  // }
}
